// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"fe1e5d9a","644":"476d4dc6","775":"ed7ab1d8","851":"12b06ff6","863":"c1118120","873":"128b1227","990":"bb9ae049"}[chunkId] + ".chunk.js";
};